export default __webpack_public_path__ + "static/media/mangal.2df62986.jpg";